import { ICoworkingForAFSchema } from '../../../../node/repositories/coworking/entities/response/CoworkingForAFSchema';

import { IMappers } from '../../../repositories/coworking/v1/get-coworkings-by-operator';
import { IApplicationContext } from '../../../types/applicationContext';

export enum EGetCoworkingsByOperatorStatus {
  CriticalError,
  Error,
  Pending,
  Success,
}

export interface IGetCoworkingsByOperatorResult {
  lkUrl: string;
  coworkings: ICoworkingForAFSchema[];
  message: string | null;
  status: EGetCoworkingsByOperatorStatus;
}

export type GetCoworkingsByOperatorDependencies = Pick<IApplicationContext, 'logger' | 'httpApi'>;

export type GetCoworkingsByOperatorMappers = IMappers<IGetCoworkingsByOperatorResult, IGetCoworkingsByOperatorResult>;
